import React, { useMemo, useState } from "react";
import { Empty, Input } from "antd";
import TransferItemCard from "./TransferItemCard";
import { TranslateText } from "@/utils/translation";
const t = (textKey) => <TranslateText textKey={textKey} namespace="pos" />;

const TransferItemList = ({ items, selectedQuantities, onQuantityChange }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const filteredItems = useMemo(() => {
    if (!searchTerm.trim()) return items;
    return items.filter((item) =>
      item?.name?.toLowerCase().includes(searchTerm?.toLowerCase()),
    );
  }, [items, searchTerm]);

  return (
    <div className="border rounded-lg overflow-hidden h-full">
      <div className="p-3 border-b">
        <Input
          allowClear
          placeholder="Search Item"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      <div className="h-[430px] overflow-y-auto p-3">
        {filteredItems.length ? (
          <div className="space-y-3">
            {filteredItems.map((item) => (
              <TransferItemCard
                key={item.id}
                item={item}
                value={selectedQuantities[item.id] ?? 0}
                onChange={onQuantityChange}
              />
            ))}
          </div>
        ) : (
          <Empty description={t("no_items_found")} />
        )}
      </div>
    </div>
  );
};

export default TransferItemList;
